import React, { PureComponent } from 'react'
import PlaybookItem from '../components/playbookItem'
import { Card, CardBody, Row, Col } from 'reactstrap'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { withApollo } from 'react-apollo';
import { GetPlaybook, UpdatePlaybook } from '../../../queries/playbook'
import { loader as Loader } from '../../Loader'

class Recommendation extends PureComponent {
  constructor(props) {
    super(props);

    this._isMounted = false;
  }

  state = {
    playbookData: null,
    loadedPlaybook: false,
    loadingPlaybook: true
  }

  componentWillMount() {
    this._isMounted = false;
    return this.props.user ? null : this.props.history.push('/unauthorized')
  }

  async componentDidMount() {
    this._isMounted = true;
    try {
      if (this._isMounted) {
        const { data: playbookData } = await this.props.client.query({
          query: GetPlaybook(),
          fetchPolicy: 'network-only',
          variables: { playbookData: { framework: 'hipaa' } }
        })

        if (playbookData && playbookData.compliancePlaybook) {
          this.setState({
            playbookData: JSON.parse(playbookData.compliancePlaybook.playbook),
            loadedPlaybook: true,
            loadingPlaybook: false
          });
        } else {
          this.setState({ loadedPlaybook: true, loadingPlaybook: false });
        }
      }
    } catch (err) {
      console.log(err.message)
      this.setState({ loadedPlaybook: true, loadingPlaybook: false });
    }
  }

  updatePlaybook = async (title, rules) => {
    try {
      await this.props.client.mutate({
        mutation: UpdatePlaybook(),
        fetchPolicy: 'no-cache',
        variables: {
          playbookData: {
            framework: 'hipaa',
            playbook: JSON.stringify(this.state.playbookData)
          }
        }
      })
    } catch (err) {
      console.log(err.message)
    }
  }

  render() {

    return (
      <div className="playbook-container">
        {!this.state.loadedPlaybook ? <Loader /> :
          <React.Fragment>
            <Row>
              <Col md={12}>
                <h3 className='page-title'>Posture Compliance Playbook</h3>
                <h3 className='page-subhead subhead'>Your custom recommendations to hit your compliance goals.</h3>
              </Col>
            </Row>
            <Row>
              {this.state.playbookData && this.state.playbookData.data ?
                this.state.playbookData.data.map((recommendation, i) => {
                  return <PlaybookItem
                    key={uuid()}
                    stepNumber={i + 1}
                    title={recommendation.title}
                    description={recommendation.description}
                    rules={recommendation.rules}
                    updatePlaybook={this.updatePlaybook}
                  />
                }) :
                <Col md={12}>
                  <Card>
                    <CardBody className='playbook'>
                      <h5>
                        You do not have a HIPAA Playbook yet. Please complete the
                      <Link to='/app/assessment/hipaa-assessment'> HIPAA Assessment</Link> first.
                    </h5>
                    </CardBody>
                  </Card>
                </Col>
              }
            </Row>
          </React.Fragment>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user
  }
}

export default withApollo(connect(mapStateToProps)(withRouter(Recommendation)))



// WEBPACK FOOTER //
// ./src/components/playbook/hipaa/HipaaPlaybook.js